

const getActiveExams = (data: any[]) => {
    if (!data) {
        return
    }

    const now = Date.now();

    return data.filter(exam_component => {
        const expirationTime = new Date(exam_component.expiration).getTime();
        return ((now < expirationTime) && (!exam_component.expired));
    });
};

export default getActiveExams;